// 文件传输表单验证与默认值
import dayjs from "dayjs";

export function defaultExpiry() {
  return dayjs().add(7, "day").hour(23).minute(59).second(59).millisecond(0);
}

export function emptyFormValues() {
  return {
    title: "",
    description: "",
    expiry: defaultExpiry(),
    maxFileSize: 10737418240, // 10GB
    maxFiles: 500,
  };
}

export function sessionToFormValues(session) {
  return {
    title: session.title || "",
    description: session.description || "",
    expiry: session.expiry ? dayjs(session.expiry * 1000) : defaultExpiry(),
    maxFileSize: session.maxFileSize || 10737418240,
    maxFiles: session.maxFiles || 500,
  };
}

/**
 * 校验表单。t 参数为可选翻译函数，不传则使用默认中文。
 */
export function validateForm(values, t) {
  const T = t || ((key) => ({
    titleRequired: "请输入标题",
    titleTooLong: "标题过长",
    descTooLong: "描述过长",
    expiryRequired: "请设置过期时间",
    expiryMustBeFuture: "过期时间必须在未来",
    maxFileSizeInvalid: "单文件大小限制无效（1B – 5TB）",
    maxFilesInvalid: "文件数量限制无效（1 – 10000）",
  }[key] || key));

  const title = (values.title || "").trim();
  const description = (values.description || "").trim();
  const maxFileSize = Number(values.maxFileSize) || 10737418240;
  const maxFiles = Number(values.maxFiles) || 500;

  if (!title) {
    throw new Error(T("fileTransfer.form.titleRequired"));
  }
  if (title.length > 500) {
    throw new Error(T("fileTransfer.form.titleTooLong"));
  }
  if (description.length > 5000) {
    throw new Error(T("fileTransfer.form.descTooLong"));
  }
  if (!values.expiry) {
    throw new Error(T("fileTransfer.form.expiryRequired"));
  }
  const expiry = Math.floor(values.expiry.valueOf() / 1000);
  if (expiry * 1000 <= Date.now()) {
    throw new Error(T("fileTransfer.form.expiryMustBeFuture"));
  }
  if (maxFileSize < 1 || maxFileSize > 5497558138880) {
    throw new Error(T("fileTransfer.form.maxFileSizeInvalid"));
  }
  if (maxFiles < 1 || maxFiles > 10000) {
    throw new Error(T("fileTransfer.form.maxFilesInvalid"));
  }

  return {
    title,
    description,
    expiry,
    maxFileSize,
    maxFiles,
  };
}

export function formatFileSize(bytes) {
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = (bytes / Math.pow(k, i)).toFixed(i > 0 ? 1 : 0);
  return `${size} ${units[i]}`;
}
